import * as React from "react";
import { IDropdownOption } from "@fluentui/react";
import {
    Dropdown,
    Option,
    SelectionEvents,
    OptionOnSelectData,
    useId
} from "@microsoft/shifts-ui-core";

const styles = require("./SlotSelector.scss");

export interface SlotSelectorProps {
    /** The available slot options */
    options: IDropdownOption[];
    /** The currently selected number of slots */
    selectedSlots: number;
    /** Callback when the selection changes */
    onSelectionChange: (selectedValue: number) => void;
    /** Aria label for accessibility */
    ariaLabel: string;
    /** Data automation ID for testing */
    automationId?: string;
    /** Additional CSS class name */
    className?: string;
    /** Appearance style of the select component */
    appearance?: "filled-darker" | "outline" | "underline";
    /** Tab index for keyboard navigation */
    tabIndex?: number;
}

/**
 * SlotSelector component using Fluent UI Select for better accessibility
 * Replaces the previous Dropdown implementation for slot selection
 */
export const SlotSelector: React.FC<SlotSelectorProps> = ({
    options,
    selectedSlots,
    onSelectionChange,
    ariaLabel,
    automationId,
    className,
    appearance,
    tabIndex
}) => {
    const selectId = useId();

    const handleSelectionChange = (event: SelectionEvents, data: OptionOnSelectData) => {
        const selectedValue = Number(data.optionValue);
        if (onSelectionChange && !isNaN(selectedValue)) {
            onSelectionChange(selectedValue);
        }
    };

    return (
        <>
            <label
                htmlFor={selectId}
                className={styles.srOnlyLabel}>
                {ariaLabel}
            </label>
            <Dropdown
                tabIndex={tabIndex}
                appearance={appearance}
                id={selectId}
                value={selectedSlots.toString()}
                onOptionSelect={handleSelectionChange}
                aria-label={ariaLabel}
                data-automation-id={automationId}
                className={className}>
                {options.map((option) => (
                        <Option
                            id={`QAIDOpenShiftSlots-slot-${option.key}`}
                            key={option.key}
                            aria-label={option.text}
                            value={option.key.toString()}>
                            {option.text}
                        </Option>
                    ))}
            </Dropdown>
        </>
    );
};
